import { createActorContext } from "@xstate/react3"
import createManageUserModulesMachine from "./manageUserModules"

const GlobalMachineContext = createActorContext(
  createManageUserModulesMachine(),
  null
  // state => console.log("[machine]", state.value, state.event, state.context)
)

export default GlobalMachineContext
